// EL % DE REINVERSIÓN LO DICE EL SERVIDOR, NO LA PANTALLA.
//
// 🔴 Por qué existe este archivo (7-sep-2026). La comisión de toda la suite vive en
// `alebas-gestion` y el giro la pregunta desde el 5-sep. El front la tenía escrita a mano en
// cuatro sitios: `CARGO_ADMIN_TEC_PCT = 20` (services/cierre.js) y los textos «Reinversión 20%» /
// «El 80% es tuyo» de `BackOffice.jsx` y `TechnicianPortal.jsx`. Coincidían por copia — la tarifa
// de la gestión se sembró con ese mismo 20 % —, así que el día que el dueño cambie el suyo el
// portal le seguiría prometiendo al técnico el 80 % viejo. Un número que se ve en pantalla y se
// liquida en el servidor sale de un solo lado o termina en dos verdades.
//
// 🪤 El defecto por defecto: mientras la respuesta no llega se usa el 20/80 de siempre, que es
// exactamente lo que se mostraba antes. No se pinta un vacío ni un «cargando» donde antes había
// una cifra; se corrige sola cuando el hub-api contesta.
import { useEffect, useState } from 'react';
import { comisionSuite } from './pagos';

/** Lo que se muestra si el hub-api no contesta: el mismo 20/80 que estaba horneado. */
export const COMISION_LOCAL = Object.freeze({
  concepto: 'instalacion', pct: 20, neto_pct: 80, fuente: 'local', motivo: 'sin_respuesta',
});

export function useComisionSuite(concepto = 'instalacion') {
  const [comision, setComision] = useState(COMISION_LOCAL);

  useEffect(() => {
    let vivo = true;
    comisionSuite(concepto)
      .then((r) => {
        const pct = Number(r && r.pct);
        if (!vivo || !r || r.ok === false || !Number.isFinite(pct)) return;
        setComision({
          concepto: r.concepto || concepto,
          pct,
          neto_pct: Number.isFinite(Number(r.neto_pct)) ? Number(r.neto_pct) : 100 - pct,
          fuente: r.fuente || 'local',
          motivo: r.motivo || null,
        });
      })
      .catch(() => { /* se queda con el 20/80: una tarifa que no llega no borra la pantalla */ });
    return () => { vivo = false; };
  }, [concepto]);

  return comision;
}
